// extracted by mini-css-extract-plugin
export default {"resourceLink":"FeatureResources_resourceLink__O-0mZ","resourceLinksWrapper":"FeatureResources_resourceLinksWrapper__CF3WH"};